import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useContext } from 'react';
import { AppContext } from '../../contexts/app/context';
import { PlaybooksPropsContext } from '../../contexts/playbooks/PropsContext';
import FeaturePopupOver from '../common/FeaturePopupOver';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PlaybooksInfoTooltip() {
  const {
    portalId,
    openUrl,
    featureTipsLink,
    reconnectRoute
  } = useContext(PlaybooksPropsContext);
  const {
    appName,
    features
  } = useContext(AppContext);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": `${appName}-playbooks-tooltip-info`,
    children: [/*#__PURE__*/_jsx(View, {
      as: "span",
      marginInlineEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `playbooks.${!features.PLAYBOOKS.available ? 'featureDisabled' : 'chooseContact'}`
      })
    }), !features.PLAYBOOKS.available ? /*#__PURE__*/_jsx(FeaturePopupOver, {
      featureDisabledReason: features.PLAYBOOKS.reason,
      portalId: portalId,
      openUrl: openUrl,
      featureTipsLink: featureTipsLink,
      reconnectRoute: reconnectRoute
    }) : /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "playbooks.onlyAssociatedContactsAvailable"
      }),
      children: /*#__PURE__*/_jsx(InfoIcon, {
        color: "icon-core-subtle",
        size: "300"
      })
    })]
  });
}
export default PlaybooksInfoTooltip;